import { Form } from 'antd';
import React, { memo } from 'react';
import { INLTSwitch as Switch } from '@xbcb/form-item-components';
import { PgaFormBaseProps } from 'types';
import { StyledEpaFormDiv, StyledInfoTooltip, StyledFlexDiv } from './styles';

const EpaForm = ({
  pgaFlag,
  disabled,
  localNamePath,
  fullNamePath,
}: PgaFormBaseProps): React.ReactElement => {
  const form = Form.useFormInstance();
  const programCode = Form.useWatch([...fullNamePath, 'programCode'], form);
  const subjectToTSCA = ['EP1', 'EP2', 'EP7', 'EP8'].includes(pgaFlag);
  return (
    <StyledEpaFormDiv>
      {subjectToTSCA && (
        <Switch
          field={[...localNamePath, 'isTscaCompliant']}
          disabled={disabled}
          onWord="Compliant"
          offWord="Not Applicable"
          label="TSCA Certification"
          aria-label="TSCA Certification"
        />
      )}
      <>
        {programCode === 'ODS' && (
          <StyledFlexDiv>
            <Switch
              disabled={disabled}
              field={[...localNamePath, 'isImageSubmitted']}
              onWord="Submitted"
              offWord="Not Applicable"
              label="Non Objection Notice"
            />
            <StyledInfoTooltip title="An image of the EPA-issued Non Objection Notice is conditionally required if the ODS has been previously used (i.e., not virgin)." />
          </StyledFlexDiv>
        )}
      </>
    </StyledEpaFormDiv>
  );
};

export default memo(EpaForm);
